<script lang="ts">var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import CardBase from "../../../common/CardBase.svelte";
import { Readable } from "svelte/store";
import { resolveUrl } from '../../../../../js/url';
export let element;
export let sources;
export let sourceStore;
$: title = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.title) || "";
$: titleColor = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.titleColor) || "#000";
$: description = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.description) || "";
$: descriptionColor = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.descriptionColor) || "#000";
$: backgroundColor =
    ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.backgroundColor) || "transparent";
$: titleFontSize = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.titleFontSize) || "14px";
$: descriptionFontSize = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.descriptionFontSize) || "12px";
$: fontFamily = (_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.fontFamily;
$: icon = (_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.icon;
</script>

<CardBase {element}>
  <div class="subscription-item-wrapper">
    <div class="img-wrapper">
        <img src={icon} alt="icon" class="icon" />
    </div>
    <div class="text-layout">
      <span
        class="title"
        style="
            --color: {titleColor};
            --fontSize: {titleFontSize};
        ">{title}</span
      >
      <span
        class="description"
        style="
            --color: {descriptionColor};
            --fontSize: {descriptionFontSize};
        ">{description}</span
      >
    </div>
  </div>
</CardBase>

<style>.subscription-item-wrapper {
  display: flex;
  align-items: center;
  font-family: "SF Pro Display";
  width: 100%;
  padding-left: 18px;
  padding-right: 18px;
}

.subscription-item-wrapper .img-wrapper {
  width: 18px;
  height: 18px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subscription-item-wrapper .text-layout {
  display: flex;
  flex-direction: column;
}

.subscription-item-wrapper .title {
  color: var(--color);
  font-size: var(--fontSize);
  font-weight: 600;
}

.subscription-item-wrapper .description {
  color: var(--color);
  font-size: var(--fontSize);
  font-weight: 400;
}

.subscription-item-wrapper .icon {
  width: auto;
  height: 18px;
}

@media screen and (min-width: 1024px) {
  .subscription-item-wrapper .text-layout {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
}</style>
